import { computed, observable, action } from "mobx";
import CustomerStore from "~/stores/CustomerStore";
import TourStore from "~/stores/TourStore";
import Customer from "~/models/Customer";
import PageStore from "~/stores/PageStore";

class CustomerPortalStore {
  /**
   * @property {CustomerStore}
   */
  customerStore = null;

  /**
   * @property {TourStore}
   */
  tourStore = null;

  /**
   * @property {PageStore}
   */
  pageStore = null;

  /**
   * @property {string}
   */
  @observable redirectTo = "";

  /**
   * @property {string}
   */
  @observable activePageName = "";

  constructor() {
    this.pageStore = new PageStore();
    this.customerStore = new CustomerStore(this);
    this.tourStore = new TourStore(this);
  }

  @computed
  get isLoading() {
    return this.customerStore.isLoading || this.tourStore.isLoading || this.pageStore.isLoading;
  }

  @computed
  get bannerFromTours() {
    const { tours } = this.tourStore;

    let banner = "https://www.urbanimmersive.com/images/masthead/tourbuzz/bg_banner_6.jpg";

    const possibleBanners = [];
    for (let i = 0; i < tours.length; i += 1) {
      if (tours[i].banner) {
        if (!tours[i].banner.includes("mp4")) {
          possibleBanners.push(tours[i].banner);
        }
      }
    }

    if (possibleBanners.length > 0) {
      banner = possibleBanners[Math.floor(Math.random() * possibleBanners.length)];
    }

    return banner;
  }

  @computed
  get coCustomer() {
    const { tourStore } = this;
    const { tours } = tourStore;
    let tourFound = false;
    let { tourId } = this.tourStore;
    let coCustomer = null;

    if (tours.length === 0) {
      return coCustomer;
    }

    for (let i = 0; i < tours.length; i += 1) {
      if (tours[i].tourId === tourId) {
        tourFound = true;
        break;
      }
    }

    if (tourFound === false) {
      tourId = null;
    }

    if (tourId == null) {
      for (let i = 0; i < tours.length; i += 1) {
        if (tours[i].coCustomer === null) {
          tourId = tours[i].tourId;
          break;
        }
      }
    }

    if (tourId === null) {
      tourId = tours[0].tourId;
    }

    for (let i = 0; i < tours.length; i += 1) {
      if (tours[i].tourId === tourId) {
        if (tours[i].coCustomer !== null) {
          coCustomer = new Customer(tours[i].coCustomer);
        } else {
          coCustomer = null;
        }
      }
    }

    if (coCustomer !== null) {
      for (let i = 0; i < tours.length; i += 1) {
        if (tours[i].coCustomer === null || tours[i].coCustomer.customerId !== coCustomer.customerId) {
          coCustomer = null;
          break;
        }
      }
    }

    if (coCustomer) {
      if (coCustomer.customerId === this.customerStore.customerId) {
        coCustomer = null;
      }
    }

    return coCustomer;
  }

  @action
  loadTourIndex(infinite) {
    return this.tourStore.loadIndex(infinite, {
      customerOrCoCustomerId: this.customerStore.customerId,
      publiclyViewable: 1,
      overrideAction: "publicIndex",
    });
  }
}

export default CustomerPortalStore;
